import { BUTTON_TEXT } from "../shared/shared.constants";

export const saveFeedbackModalConstants = {
  TITLE: BUTTON_TEXT.CONFIRM,
  MESSAGE:
    "There are some unsaved changes. Either save or discard changes to access preview.",
  SAVE_BUTTON: BUTTON_TEXT.SAVE,
  DISCARD_BUTTON: BUTTON_TEXT.DISCARD,
};
